import { render, staticRenderFns } from "./activity_child_match.vue?vue&type=template&id=fe967ca4&scoped=true"
import script from "./activity_child_match.vue?vue&type=script&lang=js"
export * from "./activity_child_match.vue?vue&type=script&lang=js"
import style0 from "./activity_child_match.vue?vue&type=style&index=0&id=fe967ca4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe967ca4",
  null
  
)

export default component.exports